// extracted by mini-css-extract-plugin
export default {"cls1":"BulkFollowListModal-cls1_E4X","cls2":"BulkFollowListModal-cls2_pq9 BulkFollowListModal-cls1_E4X"};